<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="rounded-md p-4" :class="backgroundColourClass">
      <p class="text-sm" :class="textColourClass">{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    colour: String,
    message: String,
  },
  computed: {
    backgroundColourClass () {
      return 'bg-'+this.colour+'-50'
    },
    textColourClass () {
      return 'text-'+this.colour+'-700'
    }
  }
}
</script>
